import { BaseIcon } from './base';
import type { IconProps } from './base';

export function IconEdit(props: IconProps) {
  return (
    <BaseIcon {...props}>
      <path
        d="M15.7 3.553a1.885 1.885 0 0 1 2.667 0l2.08 2.08c.737.737.737 1.93 0 2.667L8.177 20.56c-.29.307-.678.439-1.03.439H4.443A1.44 1.44 0 0 1 3 19.556v-2.702c0-.393.152-.753.426-1.027L15.7 3.553Zm1.334 1.495-1.79 1.79 1.919 1.918 1.79-1.79-1.92-1.918Zm-1.286 5.122L13.83 8.252 5 17.082V19h1.91l8.838-8.83Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
}
